export default "__VITE_ASSET__4ef45cda__"